module.exports = __webpack_public_path__ + "DINNextLTPro-Medium.eot?cf8492baf809589e5b135efe498f23ed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Medium.eot
// module id = 303
// module chunks = 0